import { createServerFn } from '@tanstack/react-start'

import {
    requestPasswordResetTokenSchema,
    updatePasswordByTokenInputSchema,
} from '@/features/Auth/PasswordReset/validation.ts'
import { validatePasswordResetTokenService } from '@/server/Auth/PasswordReset/get.service.ts'
import { updatePasswordByTokenService } from '@/server/Auth/PasswordReset/update.service.ts'

export const updatePasswordByTokenHandler = createServerFn({ method: 'POST' })
    .validator(function (data: unknown) {
        return updatePasswordByTokenInputSchema.parse(data)
    })
    .handler(async function ({ data }) {
        return updatePasswordByTokenService(data)
    })

export const validateTokenHandler = createServerFn({ method: 'GET' })
    .validator(function (data: unknown) {
        return requestPasswordResetTokenSchema.parse(data)
    })
    .handler(async function ({ data }) {
        return validatePasswordResetTokenService(data.token)
    })
